export class VehicleDetails{
    division:String;
    modelYearNumber:String;
    modelLineCode:String;
    versionCode:String;
}